









import { defineComponent } from "@vue/composition-api"

import Icon from "@/components/icon.vue"

export default defineComponent({
  components: {
    Icon,
  },
})
